import React from "react";
import {
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBIcon,
  MDBProgress,
} from "mdb-react-ui-kit";

export class SavingsRatioCard extends React.Component {
  getSavingsStatus(ratio) {
    if (ratio >= 30) return { label: "Excelente", color: "#00796b", icon: "check-circle" };
    if (ratio >= 20) return { label: "Bueno", color: "#1976d2", icon: "thumbs-up" };
    if (ratio >= 10) return { label: "Regular", color: "#f57c00", icon: "exclamation-circle" };
    if (ratio >= 0) return { label: "Bajo", color: "#d32f2f", icon: "alert-circle" };
    return { label: "Indeudamiento", color: "#880e4f", icon: "times-circle" };
  }

  render() {
    const { savingsRatio = 0 } = this.props;
    const status = this.getSavingsStatus(savingsRatio);
    
    // Limitar progress bar entre 0 y 100
    const progressValue = Math.max(0, Math.min(100, savingsRatio));

    return (
      <MDBCard>
        <MDBCardBody>
          <MDBCardTitle className="dashboard-section-title">
            <MDBIcon fas icon="piggy-bank" className="me-2" />
            Ratio de ahorro
          </MDBCardTitle>
          
          <div className="text-center py-4">
            <div style={{ fontSize: "3rem", fontWeight: "bold", color: status.color }}>
              {savingsRatio.toFixed(1)}%
            </div>
            <div className="mt-2">
              <MDBIcon fas icon={status.icon} style={{ color: status.color, marginRight: "0.5rem" }} />
              <span style={{ color: status.color, fontWeight: "bold" }}>{status.label}</span>
            </div>
          </div>

          <MDBProgress value={progressValue} color={
            savingsRatio >= 30 ? "success" : 
            savingsRatio >= 20 ? "info" : 
            savingsRatio >= 10 ? "warning" : "danger"
          } />

          <p className="text-muted text-center mt-3 small mb-0">
            Porcentaje de ingresos ahorrados este mes
          </p>
        </MDBCardBody>
      </MDBCard>
    );
  }
}
